import {FormModel} from '../../form/form.model.abstract';
import {Validators} from '@angular/forms';
import {FormModelRadio} from '../../form/form.model.radio';
import {ValidationService} from '../../services/validation.service';
import {FormModelNumber} from '../../form/form.model.number';
import {StancheckForm} from "../stancheck.form";

/**
 * Configuration for the input of the first chapter in the stromcheck advisor.
 * @inheritDoc
 */
export class HaushaltForm extends StancheckForm {

  /**
   * @inheritDoc
   *
   * ATTENTION: Some of these values/fields are also used in StromcheckController.php. Check changes also there.
   *
   * @protected
   */
  protected fields: FormModel[] = [
    // Waschen und Spülen
    new FormModelRadio('exist_ws_gs', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_ws_wm', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_ws_tr', ['ja', 'nein'], [Validators.required], null, null, false),

    // Geräteinformationen
    (new FormModelRadio('size_ws_gs', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_ws_gs', ['neu', 'mittel', 'alt'], [Validators.required])),
    (new FormModelNumber('t_ws_gs', [Validators.required, ValidationService.greaterZero], 'nutzung_woche', 0)),

    (new FormModelRadio('size_ws_wm', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_ws_wm', ['neu', 'mittel', 'alt'], [Validators.required])),
    (new FormModelNumber('t_ws_wm', [Validators.required, ValidationService.greaterZero], 'nutzung_woche', 0)),

    (new FormModelRadio('ws_tr_winter_only', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelRadio('size_ws_tr', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_ws_tr', ['neu', 'mittel', 'alt'], [Validators.required])),
    (new FormModelNumber('t_ws_tr', [Validators.required, ValidationService.greaterZero], 'nutzung_woche', 0)),

    new FormModelRadio('exist_kg_ks', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_kg_kgk', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_kg_gt', ['ja', 'nein'], [Validators.required], null, null, false),

    (new FormModelRadio('size_kg_ks', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_kg_ks', ['neu', 'mittel', 'alt'], [Validators.required])),

    (new FormModelRadio('size_kg_kgk', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_kg_kgk', ['neu', 'mittel', 'alt'], [Validators.required])),

    (new FormModelRadio('size_kg_gt', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_kg_gt', ['neu', 'mittel', 'alt'], [Validators.required])),

    new FormModelRadio('exist_kb_herd', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('type_kb_herd', ['gusseisen', 'ceran', 'induktion'], [Validators.required])),
    (new FormModelNumber('t_kb_herd', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0)),

    new FormModelRadio('exist_kb_back', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('size_kb_back', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('age_kb_back', ['neu', 'mittel', 'alt'], [Validators.required])),
    (new FormModelNumber('t_kb_back', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0)),

    new FormModelRadio('exist_kb_kaffee', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('type_kb_kaffee', ['filter', 'pad', 'vollautomat', 'siebtraeger'], [Validators.required])),
    (new FormModelNumber('n_kb_kaffee', [Validators.required, ValidationService.greaterZero], 'anzahl_tag', 0)),
    (new FormModelNumber('t_kb_kaffee', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0)),

    new FormModelRadio('exist_kb_mikrowelle', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelNumber('t_kb_mikrowelle', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0, false)),

    new FormModelRadio('exist_kb_wkocher', ['ja', 'nein'], [Validators.required], null, null, null),
    (new FormModelNumber('t_kb_wkocher', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0, null)),

    new FormModelRadio('exist_kb_toast', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelNumber('t_kb_toast', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0)),

    new FormModelRadio('exist_kb_thermomix', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelNumber('t_kb_thermomix', [Validators.required, ValidationService.greaterZero], 'minuten_tag', 0)),

    new FormModelRadio('exist_kb_dunstabzug', ['ja', 'nein'], [Validators.required], null, null, false),

    new FormModelRadio('ue_router_off', ['ja', 'nein', 'nicht_vorhanden'], [Validators.required], null, null, false),

    // Fernseher
    new FormModelRadio('exist_ue_tv', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('size_ue_tv', ['klein', 'gross'], [Validators.required])),
    (new FormModelRadio('type_ue_tv', ['led', 'plasma', 'lcd', 'oled', 'unbekannt'], [Validators.required])),
    (new FormModelNumber('t_ue_tv', [Validators.required, ValidationService.greaterZero], 'unit.stunden_woche', 0)),

    // Computer
    new FormModelRadio('exist_ue_pc', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('type_ue_pc', ['laptop', 'tablet', 'office', 'gaming'], [Validators.required])),
    (new FormModelNumber('t_ue_pc', [Validators.required, ValidationService.greaterZero], 'unit.stunden_woche', 0)),

    new FormModelRadio('exist_ue_laptop', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelNumber('t_ue_laptop', [Validators.required, ValidationService.greaterZero], 'unit.stunden_woche', 0)),

    new FormModelRadio('exist_ue_konsole', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelNumber('t_ue_konsole', [Validators.required, ValidationService.greaterZero], 'unit.stunden_woche', 0)),

    new FormModelRadio('exist_ue_hifi', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelNumber('t_ue_hifi', [Validators.required, ValidationService.greaterZero], 'unit.stunden_woche', 0)),

    new FormModelRadio('exist_ue_monitor', ['ja', 'nein'], [Validators.required], null, null, null),
    (new FormModelNumber('t_ue_monitor', [Validators.required, ValidationService.greaterZero], 'unit.stunden_woche', 0, null)),
  ];
  /**
   * List of formfields where changes of the value, change other fields.
   */
  fieldsForFormChanges: string[] = [
    'exist_ws_gs', 'exist_ws_wm', 'exist_ws_tr', 'exist_kg_ks', 'exist_kg_kgk', 'exist_kg_gt', 'exist_kb_herd',
    'exist_kb_back', 'exist_kb_kaffee', 'exist_kb_mikrowelle', 'exist_kb_wkocher', 'exist_kb_toast',
    'exist_kb_thermomix', 'exist_ue_tv', 'exist_ue_pc', 'exist_ue_laptop', 'exist_ue_konsole', 'exist_ue_hifi',
    'exist_ue_monitor'
  ];

  /**
   * @inheritDoc
   * @protected
   */
  protected groups = {
    'waschen-und-spuelen/1': ['exist_ws_gs'],
    'waschen-und-spuelen/2': ['size_ws_gs', 'age_ws_gs', 't_ws_gs'],
    'waschen-und-spuelen/3': ['exist_ws_wm'],
    'waschen-und-spuelen/4': ['size_ws_wm', 'age_ws_wm', 't_ws_wm'],
    'waschen-und-spuelen/5': ['exist_ws_tr'],
    'waschen-und-spuelen/6': ['ws_tr_winter_only', 'size_ws_tr', 'age_ws_tr', 't_ws_tr'],
    'kuehlen-und-gefrieren/1': ['exist_kg_ks', 'exist_kg_kgk', 'exist_kg_gt'],
    'kuehlen-und-gefrieren/2': ['size_kg_ks', 'age_kg_ks'],
    'kuehlen-und-gefrieren/3': ['size_kg_kgk', 'age_kg_kgk'],
    'kuehlen-und-gefrieren/4': ['size_kg_gt', 'age_kg_gt'],
    'kochen-und-backen/1': ['exist_kb_herd'],
    'kochen-und-backen/2': ['type_kb_herd', 't_kb_herd'],
    'kochen-und-backen/3': ['exist_kb_back'],
    'kochen-und-backen/4': ['size_kb_back', 'age_kb_back', 't_kb_back'],
    'kochen-und-backen/5': ['exist_kb_kaffee'],
    'kochen-und-backen/6': ['type_kb_kaffee', 'n_kb_kaffee', 't_kb_kaffee'],
    'kochen-und-backen/7': ['exist_kb_mikrowelle', 't_kb_mikrowelle'],
    'kochen-und-backen/8': ['exist_kb_wkocher', 't_kb_wkocher'],
    'kochen-und-backen/9': ['exist_kb_toast', 't_kb_toast'],
    'kochen-und-backen/10': ['exist_kb_thermomix', 't_kb_thermomix'],
    'kochen-und-backen/11': ['exist_kb_dunstabzug'],
    'unterhaltungselektronik/1': ['exist_ue_tv'],
    'unterhaltungselektronik/2': ['size_ue_tv', 'type_ue_tv', 't_ue_tv'],
    'unterhaltungselektronik/3': ['exist_ue_pc'],
    'unterhaltungselektronik/4': ['type_ue_pc', 't_ue_pc'],
    'unterhaltungselektronik/5': ['exist_ue_konsole', 't_ue_konsole'],
    'unterhaltungselektronik/6': ['exist_ue_hifi', 't_ue_hifi'],
    'unterhaltungselektronik/7': ['exist_ue_monitor'],
    'unterhaltungselektronik/8': ['t_ue_monitor'],
    'unterhaltungselektronik/9': ['ue_router_off'],
  };

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: { [key: string]: any }): { [key: string]: any } {
    const rules = [
      {check: 'exist_ws_gs', change: ['size_ws_gs', 'age_ws_gs', 't_ws_gs']},
      {check: 'exist_ws_wm', change: ['size_ws_wm', 'age_ws_wm', 't_ws_wm']},
      {check: 'exist_ws_tr', change: ['ws_tr_winter_only', 'size_ws_tr', 'age_ws_tr', 't_ws_tr']},
      {check: 'exist_kg_ks', change: ['size_kg_ks', 'age_kg_ks']},
      {check: 'exist_kg_kgk', change: ['size_kg_kgk', 'age_kg_kgk']},
      {check: 'exist_kg_gt', change: ['size_kg_gt', 'age_kg_gt']},
      {check: 'exist_kb_herd', change: ['type_kb_herd', 't_kb_herd']},
      {check: 'exist_kb_back', change: ['size_kb_back', 'age_kb_back', 't_kb_back']},
      {check: 'exist_kb_kaffee', change: ['type_kb_kaffee', 'n_kb_kaffee', 't_kb_kaffee']},
      {check: 'exist_kb_mikrowelle', change: ['t_kb_mikrowelle']},
      {check: 'exist_kb_wkocher', change: ['t_kb_wkocher']},
      {check: 'exist_kb_toast', change: ['t_kb_toast']},
      {check: 'exist_kb_thermomix', change: ['t_kb_thermomix']},
      {check: 'exist_ue_tv', change: ['size_ue_tv', 'type_ue_tv', 't_ue_tv']},
      {check: 'exist_ue_pc', change: ['type_ue_pc', 't_ue_pc']},
      {check: 'exist_ue_konsole', change: ['t_ue_konsole']},
      {check: 'exist_ue_hifi', change: ['t_ue_hifi']},
      {check: 'exist_ue_monitor', change: ['t_ue_monitor']},
    ];
    for (const rule of rules) {
      if (values.hasOwnProperty(rule.check)) {
        const activate = values[rule.check] === 'ja';
        for (const field of rule.change) {
          if (activate) {
            this.activateField(field);
          } else {
            // deactivate main field
            this.deactivateField(field);
            values[field] = null;

            // delete values of subfields
            for (let index = 1; index < 5; index++) {
              const listField = field + index;
              if (!values.hasOwnProperty(listField)) {
                break;
              }
              delete(values[listField]);
            }
          }
        }
      }
    }
    return values;
  }
}
